import request from '@/utils/request'

/* 获取通知 */
export function noticeList(data) {
	return request({
		url: '/system/userNotice/myList',
		method: 'get',
		params: data
	})
}
/* 全部标记为已读 */
export function readAllNotice(data) {
	return request({
		url: '/system/userNotice/readAllNotice',
		method: 'put'
	})
}
/* 全部标记为已读 */
export function readNotice(data) {
	return request({
		url: '/system/userNotice',
		method: 'put',
		data
	})
}
/* 删除通知 */
export function removeNotice(data) {
	return request({
		url: '/system/userNotice/' + data,
		method: 'delete'
	})
}

/* 获取系统设置 */
export function configKey(key) {
	return request({
		url: '/system/config/configKey/' + key,
		method: 'get'
	})
}


/* 扫码获取内容 */
export function seeQrCode(data) {
	return request({
		url: '/portal/case/seeQrCode',
		method: 'get',
		headers: {
			isToken: false
		},
		params: data
	})
}

/* 获取系统公告 */
export function getNotice(data) {
	return request({
		url: '/system/notice/list',
		method: 'get',
		params: data
	})
}
/* 获取字典数据 */
export function getDictData(type) {
	return request({
		url: '/system/dict/data/type/'+type,
		method: 'get'
	})
}

// 合同类型下拉列表
export function contractTypeList(data) {
	return request({
		url: '/case/contractType/selectList',
		method: 'get',
		params: data
	})
}

//获取参数
export function getConfigKey(key) {
	return request({
	  url: '/system/config/configKey/'+key,
	  method: 'get'
	})
}

//添加履行计划
export function addContractReviewPlan(data) {
	return request({
		url: '/portal/case/nonLitigation/addContractReviewPlan',
		method: 'post',
		data: data,
		loading:true
	})
}

//修改履行计划
export function editContractReviewPlan(data) {
	return request({
		url: '/case/nonContractReviewPlan',
		method: 'put',
		data: data,
		loading:true
	})
}
//删除履行计划
export function deleteContractReviewPlan(id) {
	return request({
		url: '/case/nonContractReviewPlan/'+id,
		method: 'delete',
		loading:true
	})
}
// 获取履行计划列表
export function mylistNonContractReviewPlan(data) {
	return request({
		url: '/portal/case/nonLitigation/mylistNonContractReviewPlan',
		method: 'get',
		params: data
	})
}
